import React, { useEffect } from 'react';
import TextField from '@mui/material/TextField';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import InputAdornment from '@mui/material/InputAdornment';

const SearchBoxHomePage = ({ calculationsData, query, setQuery, setFilteredCalculations, setMatchingResult }) => {
  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      const normalizedQuery = query.trim().toLowerCase();
      const filteredCalculations = calculationsData.filter((calculation) => {
        if (normalizedQuery === '') return true;
        return `${calculation.description} ${calculation.title}`.toLowerCase().includes(normalizedQuery);
      });

      setMatchingResult(filteredCalculations.length === 0 && normalizedQuery.length > 0);
      setFilteredCalculations(
        filteredCalculations.sort((a, b) => {
          if (a.title < b.title) return -1;
          if (a.title > b.title) return 1;
          return 0;
        })
      );
    }, 120);

    return () => clearTimeout(debounceTimer);
  }, [query, calculationsData, setFilteredCalculations, setMatchingResult]);

  return (
    <div className="homepage-searchbox-container">
      <div className="homepage-searchbox">
        <TextField
          fullWidth
          sx={{ minWidth: '250px', maxWidth: '700px' }}
          size="small"
          label="Search Calculations"
          type="search"
          placeholder="Settlement, Terzaghi, Bearing Capacity..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <SearchRoundedIcon fontSize={'large'} color={'info'} />
              </InputAdornment>
            ),
          }}
        ></TextField>
      </div>
    </div>
  );
};

export default SearchBoxHomePage;
